/* eslint-disable */

import React from 'react'
import http from '../../Component/Interceptor/Interseptor'

import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import jMoment from 'moment-jalali'
import {Link} from 'react-router-dom'
import {Pagination} from 'antd'
import RETAIL from '../BaseComponent/RETAIL'
import {Map, Marker, TileLayer, Popup} from 'react-leaflet'

class ActiveDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      drivers: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      length: '',
      current: 1,
      pageSize: 10,
      partDriver: [],
      positionDriver: false,
      loading: false
    }
  }

  onMarkerClick(props, marker) {
    console.log(marker)
    // console.log(props);
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  }

  componentDidMount() {
    http
      .get(`${RETAIL.RETAIL_MANAGE_LOCATION_DRIVER_LIST}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          let data = response.data.object
          for (const element of data) {
            if (element['state'] == '-100') {
              element['stateText'] = 'کنسل'
            } else if (element['state'] == '-10') {
              element['stateText'] = 'خارج از سرویس'
            } else if (element['state'] == '-5') {
              element['stateText'] = 'عدم ارسال موقعیت'
            } else if (element['state'] == '1') {
              element['stateText'] = 'فعال'
            } else if (element['state'] == '5') {
              element['stateText'] = 'شروع شده'
            } else if (element['state'] == '9') {
              element['stateText'] = 'تمام شده'
            }
            element['isChecked'] = false
          }

          this.setState({
            drivers: response.data.object,
            partDriver: response.data.object.slice(0, 10),
            length: response.data.object.length
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    setInterval(() => {
      http
        .get(`${RETAIL.RETAIL_MANAGE_LOCATION_DRIVER_LIST}`, {})
        .then((response) => {
          if (response.data.error == null) {
            console.log(response.data)
            let data = response.data.object
            for (const element of data) {
              if (element['state'] == '-100') {
                element['stateText'] = 'کنسل'
              } else if (element['state'] == '-10') {
                element['stateText'] = 'خارج از سرویس'
              } else if (element['state'] == '-5') {
                element['stateText'] = 'عدم ارسال موقعیت'
              } else if (element['state'] == '1') {
                element['stateText'] = 'فعال'
              } else if (element['state'] == '5') {
                element['stateText'] = 'شروع شده'
              } else if (element['state'] == '9') {
                element['stateText'] = 'تمام شده'
              }
            }

            this.setState({
              drivers: response.data.object
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }, 5000)
  }

  componentWillUnmount() {
    for (let i = 0; i < 100; i++) {
      window.clearInterval(i)
    }
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partDriver: this.state.drivers.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  changeSizePage(current, pageSize) {
    console.log(current, pageSize)
  }

  showDriverOnMap = (numId) => {
    sessionStorage.setItem('lat', this.state.partDriver[numId].location.lat)
    sessionStorage.setItem('lon', this.state.partDriver[numId].location.lon)
    sessionStorage.setItem('name', this.state.partDriver[numId].driverInfo.name)
    sessionStorage.setItem(
      'timeStamp',
      jMoment(this.state.partDriver[numId].location.timestamp).format('jYYYY/jMM/jDD HH:mm:ss')
    )
    this.setState({
      positionDriver: !this.state.positionDriver
    })
  }

  cancelPosition = () => {
    this.setState({
      positionDriver: !this.state.positionDriver
    })
    // sessionStorage.removeItem("lat");
    sessionStorage.removeItem('name')
    // sessionStorage.removeItem("lon");
    sessionStorage.removeItem('timeStamp')
  }

  togglePosition = () => {
    this.setState({
      positionDriver: !this.state.positionDriver
    })
    // sessionStorage.removeItem("lat");
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('timeStamp')
    // sessionStorage.removeItem("lon");
  }

  getMarkers() {
    let points = this.state.drivers
    const array = []
    points.forEach((item) => {
      if (item.location.lat && item.location.lon) {
        array.push({
          location: [item.location.lat, item.location.lon],
          ...item
        })
      }
    })
    return array
  }

  render() {
    const style = {
      width: '100%',
      height: '400px',
      margin: 'auto',
      position: 'relative !important'
    }

    const modalStyle = {
      maxWidth: '96%',
      height: '300px'
    }

    let pageNumber = this.state.current

    // let timeStamp=sessionStorage.getItem('timeStamp')

    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>رساننده های فعال</li>
          </ul>
          <div className="addressMap">
            <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item) => (
                <Marker position={item.location}>
                  <Popup>
                    <p className="text-center">{item.driverInfo.name}</p>
                    <p>
                      ساعت :‌
                      {'  ' + item.location.timestamp &&
                        jMoment(item.location.timestamp).format('jYYYY/jMM/jDD HH:mm:ss')}
                    </p>
                  </Popup>
                </Marker>
              ))}
            </Map>
          </div>

          <div className="tableComponent">
            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>نام کاربری</td>
                  <td>نام</td>
                  <td>شناسه</td>
                  <td>ورژن اپلیکیشن</td>
                  <td>موبایل</td>
                  <td>آخرین ارسال موقعیت</td>
                  <td>حالت</td>
                  <td>نمایش در نقشه</td>
                  <td>فاکتور ها</td>
                  <td>ویرایش فاکتور ها</td>
                </tr>
                {this.state.partDriver.map((driver, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * 10 + index + 1}</td>

                    <td>{driver.driverInfo.username}</td>
                    <td>{driver.driverInfo.name}</td>
                    <td>{driver.driverInfo.personId}</td>
                    <td>{driver.version === null ? '-' : driver.version}</td>
                    <td>{driver.driverInfo.mobile}</td>
                    <td>
                      {driver.location.timestamp == null
                        ? '-'
                        : jMoment(driver.location.timestamp).format('jYYYY/jMM/jDD HH:mm:ss')}
                    </td>
                    <td>{driver.stateText == null ? '-' : driver.stateText}</td>
                    <td>
                      <button
                        style={driver.location.timestamp == null ? {display: 'none'} : {display: 'inline-block'}}
                        onClick={() => this.showDriverOnMap(index)}
                      >
                        <img src={require('../../image/loc.svg')} alt="" />
                      </button>
                    </td>
                    <td>
                      <Link
                        to={`/DriverFactor/${driver.dispatchId}/${driver.driverInfo.name}`}
                        disabled={driver.dispatchId == null ? true : false}
                      >
                        {driver.dispatchId == null ? (
                          <img src={require('../../image/deactiveBill.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/bill.svg')} alt="" />
                        )}
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`/EditFactorDrivers/${Number(driver.dispatchId)}/driver=${Number(
                          driver.driverInfo.personId
                        )}/${driver.driverInfo.name}`}
                        disabled={driver.dispatchId == null ? true : false}
                      >
                        {driver.dispatchId == null ? (
                          <img src={require('../../image/deactiveeditDriver.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        )}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Pagination
                current={this.state.current}
                onChange={this.onChangePage.bind(this)}
                onShowSizeChange={this.changeSizePage.bind(this)}
                total={this.state.length}
              />
              ,
            </div>

            <Modal isOpen={this.state.positionDriver} toggle={this.togglePosition} size="lg">
              <ModalHeader toggle={this.togglePosition}>
                <p>
                  {' '}
                  موقعیت کنونی {sessionStorage.getItem('name') + ' در زمان ' + sessionStorage.getItem('timeStamp')}
                </p>
              </ModalHeader>
              <ModalBody>
                <div className="addressMap">
                  <Map center={[35.6892, 51.389]} zoom={10}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={[sessionStorage.getItem('lat'), sessionStorage.getItem('lon')]}>
                      {/* <Popup>
                        <p className="text-center">{item.driverInfo.name}</p>
                      </Popup> */}
                    </Marker>
                  </Map>
                </div>
              </ModalBody>
              <ModalFooter>
                <button className="cancelBtnModal" onClick={this.cancelPosition}>
                  لغو
                </button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveDrivers
